<template lang="pug">
.communityq-story-template-field
  select.form-control(v-model="selectedId")
    option
    option(
      v-for="storyTemplate in storyTemplates"
      :value="storyTemplate.id"
      :key="storyTemplate.id"
    )
      | {{ storyTemplate.title }}
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  props: {
    publicationId: {
      required: true,
      type: Number
    },
    value: {
      type: Number,
      required: false
    }
  },

  computed: {
    storyTemplates: sync('communityqStoryTemplates/storyTemplates'),

    selectedId: {
      get() { return this.value },
      // Emits the value to support usage with v-model. The change will then
      //flow back down through the value prop, so we don't need to set it here.
      set(val) {
        const intVal = parseInt(val);
        // Convert non-id values to null i.e. 0 or NaN
        const idValue = (intVal > 0 ? intVal : null);
        this.$emit('input', idValue);
      }
    }
  },

  mounted() {
    this.$store.dispatch('communityqStoryTemplates/fetchOnce', this.publicationId);
  }
}
</script>
